/* esm.sh - applesauce-common@5.2.0/dist/operations/channel */
export * from "/*applesauce-common@5.2.0/esnext/dist/operations/channel.mjs";
